'use client';

import './donate-card.scss';

import React from 'react';

import { cn } from '@sola/ark-core/utils/helpers.js';
import { FlexibleContentProps, Templates } from '@sola/schema/lib/schema.js';
import { TrackViewFund } from '@sola/tracking/components/datalayer.js';

import { Image } from '../../../atoms/image/image';
import {
  FeatureBase,
  FeatureBaseProps,
} from '../../../molecules/feature-base/feature-base';
import { FeatureButtons } from '../../../molecules/feature-buttons/feature-buttons';
import { getBaseSizeProps } from '../../../utils/text-utils';
import { DonateProvider } from './donate-context';
import { DonateForm } from './donate-form';
import { DonateVariants } from './donate.types';

// @TODO: This card should be a molecule when the donate logic moves to a library at somepoint

export const DonateCard: React.FC<
  FlexibleContentProps & {
    displayLevel?: number;
    variant?: DonateVariants;
    focusOnLoad?: boolean;
    className?: string;
    alt?: boolean;
  }
> = ({
  seoLevel = 2,
  displayLevel,
  media,
  mediaLogo,
  primaryCTA,
  secondaryCTA,
  tertiaryCTA,
  variant = DonateVariants.default,
  focusOnLoad = false,
  className,
  alt,
  ...props
}) => {
  const featureBaseProps = FeatureBaseProps.parse(props);

  const hasHeaderContent = props.title || props.body;
  const hasButtons = !!primaryCTA || !!secondaryCTA || !!tertiaryCTA;

  // Don't track interstitials.
  const shouldTrackView =
    props.mergeFieldData?.pageData?.template === Templates.enum.giftCatalog ||
    props.mergeFieldData?.pageData?.template === Templates.enum.donate;

  return (
    <div className={cn('DonateCard', className)}>
      {shouldTrackView && <TrackViewFund fund={props.fund} />}
      {media && (
        <div className="DonateCard__media">
          <Image
            image={media.image}
            aspectRatio="16-9"
            priority={seoLevel === 1}
          />
        </div>
      )}
      <div className="DonateCard__content p-comfy-lg @md:p-roomy-xs flex flex-col gap-comfy-lg">
        {hasHeaderContent && (
          <FeatureBase
            {...featureBaseProps}
            {...getBaseSizeProps(displayLevel || seoLevel)}
            seoLevel={seoLevel}
            media={mediaLogo}
          />
        )}
        {props.fund && (
          <DonateProvider
            {...props}
            seoLevel={hasHeaderContent ? seoLevel + 1 : seoLevel}
            variant={variant}
          >
            <DonateForm focusOnLoad={focusOnLoad} alt={alt} />
          </DonateProvider>
        )}
      </div>
      {variant === DonateVariants.grid && hasButtons && (
        <div className="DonateCard__actions p-comfy-lg">
          <FeatureButtons
            {...{ primaryCTA, secondaryCTA, tertiaryCTA }}
            alignment="center"
            isLinks
          />
        </div>
      )}
    </div>
  );
};
